module.exports = __webpack_public_path__ + "static/media/NE-lgo.df88a2b1.png";